import { render, staticRenderFns } from "./snackbar.vue?vue&type=template&id=5c389fbe&scoped=true"
import script from "./snackbar.vue?vue&type=script&lang=js"
export * from "./snackbar.vue?vue&type=script&lang=js"
import style0 from "./snackbar.vue?vue&type=style&index=0&id=5c389fbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@6.11.0_webpack@5.109.2_postcss@8_3af7dec0bf3d0a51e27ccc55ef35200c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c389fbe",
  null
  
)

export default component.exports